<template>
  <div class="container-md ">
    <div class="container-bg p-4 mem-outer-wrap">
      <h3>Oud Leden: {{ inactiveMembers }}</h3>
      <div class="row">
        <div class="col-md-9 col-12">
          <div class="float-right mem-srch-wrap">
            <input
              class="search-box"
              type="text"
              v-model="query"
              placeholder="Zoeken"
            />
            <button class="search-btn">
              <img
                src="/assets/img/search.svg"
                alt="Search"
                style="margin-bottom: 4px"
              />
            </button>
          </div>
        </div>
        <div class="col-md-2 col-6 float-md-left float-right">
          <!-- <button class="btn btn-dark ml-3">Export</button> -->
        </div>
        <div class="col-md-1 col-6 float-md-left float-left">
          <a href="/profile/create" class="text-black mem-plus-a">
            <i
              class="fa fa-plus"
              style="line-height: inherit; font-size: 32px; cursor: pointer"
            ></i>
          </a>
        </div>
      </div>
      <div class="flex-container d-lg-flex d-md-none mem-titl-wrap">
        <div class="item text-uppercase">Lid</div>
        <div class="item text-uppercase">Commissies</div>
        <div class="item text-uppercase">Taken</div>
      </div>
      <div
        class="flex-container flex-body mt-3"
        v-for="member in filterMembers"
        :key="'member_' + member.id"
        :class="{ 'bg-dark': !member.active }"
      >
        <div class="item text-center">
          <img
            :src="
              member.profile_image ? member.profile_image : '/assets/icon.jpg'
            "
            alt=""
            style="
              border: 1px solid #ffffff;
              border-radius: 50%;
              width: 50px;
              height: 50px;
              background-color: #fff;
            "
          />
        </div>
        <div class="item text-white" v-if="member.display_name">
          {{ member.display_name }}
        </div>
        <div class="item text-white" v-else>
          {{ member.firstname }} {{ member.lastname }}
        </div>
        <div class="item text-white">{{ member.names_committees }}</div>
        <div class="item text-white">{{ member.names_responsibilities }}</div>
        <div class="item text-white">
          <a
            :href="'/profile/' + member.id + '/view'"
            class="text-white"
            style="margin-right: 10px"
            ><i class="fa fa-eye"></i
          ></a>
          <a :href="'/profile/' + member.id + '/edit'" class="text-white"
            ><i class="fas fa-pencil-alt"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "inactiveMembers",
  data() {
    return {
      members: [],
      query: "",
    };
  },

  mounted() {
    // Pull current users
    this.$store
      .dispatch("get", "/api/v1/inactive/users")
      .then((data) => {
        this.members = data.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });
  },
  computed: {
    inactiveMembers: function () {
      if (this.members.length > 0) {
        return this.members.filter((member) => {
          // if(member.member_end === null){
          //     return false;
          // }
          //
          // if(Date.parse(member.member_end)-Date.parse(new Date()) <0){
          //     return false;
          // }
          console.log(member);
          return true;
        }).length;
      }
      return 0;
    },
    filterMembers: function () {
      if (this.members.length > 0 && this.query) {
        return this.members.filter((member) => {
          if (!member) {
            return false;
          }
          if (!member.display_name) {
            return false;
          }
          if (member.display_name && member.firstname && member.lastname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.firstname.toLowerCase().match(this.query.toLowerCase()) ||
              member.lastname.toLowerCase().match(this.query.toLowerCase())
            );
          } else if (member.display_name && member.firstname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.firstname.toLowerCase().match(this.query.toLowerCase())
            );
          } else if (member.display_name && member.lastname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.lastname.toLowerCase().match(this.query.toLowerCase())
            );
          } else {
            return member.display_name
              .toLowerCase()
              .match(this.query.toLowerCase());
          }
        });
      } else if (this.members.length > 0) {
        return this.members;
      } else {
        return [];
      }
    },
  },
  created() {
    this.$store.dispatch("get", "/api/v1/inactive/users").then((data) => {
      console.log(data);
      this.members = data.data.data;
    });
  },
};
</script>

<style scoped>
.inactive {
  /*background: #292929;*/
}

.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #292929;
  border-radius: 4px;
  height: 40px;
  width: 20rem;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -30px;

  -webkit-appearance: none;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 18px !important;
}

.custom-row {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  opacity: 1;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  padding: 20px 0;
  width: auto;
}
</style>
